<template>
  <div
    class="py-2 px-3 text-sm text-gray-600 border-2 focus:border-blue-500 block w-full rounded-lg mb-2 bg-gray-100 animate-pulse outline-none uppercase"
    v-show="loading"
  >
    Cargando tipo de productos
  </div>
  <select
    class="py-2 px-3 text-sm text-gray-600 uppercase border-2 focus:border-blue-500 block w-full rounded-lg mb-2 bg-gray-50 outline-none"
    v-model="vModelSelectOptions"
    @change="sendDataSelect"
    v-show="!loading"
  >
    <option value="null" :disabled="isDisabled">Selecciona tipo de producto</option>
    <option :value="resgiter.id" v-for="(resgiter, i) in registers" :key="i">
      {{ resgiter.descripcion }}
    </option>
  </select>
</template>
<script>
import { onMounted, ref } from "vue";
import axios from "../../api";
import { errorActions } from "@/alerts";
export default {
  name: "TypeOfProducts",
  props: {
    selectOption: {
      type: Number,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default:true
    },
  },
  emits: ['send-data'],//Si da problemas eliminarlo
  setup(props, { emit }) {
    const registers = ref([]);
    const loading = ref(true);
    const vModelSelectOptions = ref(1);

    //funcion para enviar datos desde este componente hacia el otro componente
    const sendDataSelect = () => {
      emit("send-data", vModelSelectOptions.value);
    };
    onMounted(async () => {
      try {
        const response = await axios
          .get("tipo-de-productos/?page=1&per_page=300")
          .catch((error) => errorActions(error));
        registers.value = await response.data.data;
        if (registers.value.length === 0) {
          return errorActions(
            "Lo sentimos no hemos encontrado un turno en nuestra base de datos"
          );
        }
        if (props.selectOption != "" && props.selectOption !== undefined) {
          vModelSelectOptions.value = props.selectOption || 1;
          emit("send-data", vModelSelectOptions.value);
        } else {
          vModelSelectOptions.value = null;
        }
        loading.value = false;
      } catch (error) {
        errorActions(error);
      }
    });
    return {
      registers,
      loading,
      vModelSelectOptions,
      sendDataSelect,
    };
  },
};
</script>
